import parsePhoneNumberFromString from 'libphonenumber-js';

type FormattedTelephoneData = {
    formated: string;
    href: string;
};

export function getFormatedPhoneNumber(telephone: string): FormattedTelephoneData;
export function getFormatedPhoneNumber(prefix: string, telephone: string): FormattedTelephoneData;
export function getFormatedPhoneNumber(telephoneOrPrefix: string, telephone?: string) {
    const raw = telephone ? `${telephoneOrPrefix}${telephone}` : telephoneOrPrefix;
    const formated = parsePhoneNumberFromString(raw)?.formatInternational() ?? raw;
    return { formated, href: `tel:${formated}` };
}
